import '@babel/polyfill'
import 'whatwg-fetch'
import Vue from 'vue'
import './plugins/vuetify'
import './plugins/amplify'
import './plugins/sweetalert'
import './plugins/lodash'
import './plugins/validate'
import './plugins/snotify'
import './plugins/pass'
import './plugins/moment'
import App from './App.vue'
import router from './router'
import store from './store/index'

//Vue.prototype.$axios = dev

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')